import React from 'react';
import { LeaderboardEventSummary } from '../../api/leaderboard-events';
import './StatsCards.scss';

interface StatsCardsProps {
  summary?: LeaderboardEventSummary | null;
}

const StatsCards: React.FC<StatsCardsProps> = ({ summary }) => {
  return (
    <div className="stats-cards">
      <div className="stat-card">
        <span className="stat-label">Total Clients</span>
        <span className="stat-value">{summary?.totalClients ?? 0}</span>
      </div>
      <div className="stat-card">
        <span className="stat-label">Total Users</span>
        <span className="stat-value">{summary?.totalParticipants ?? 0}</span>
      </div>
    </div>
  );
};

export { StatsCards };
